import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import InputClone from "./InputClone";

const styles = (theme) => ({});

class ClonePlayerInputForm extends Component {
  render() {
    const { clonePlayer, handlePropChange } = this.props;
    return (
      <React.Fragment>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "number",
              label: "Credit Limit",
              property: clonePlayer.creditLimit,
              propertyName: "creditLimit",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "number",
              label: "Phone Limit Min",
              property: clonePlayer.phoneLimitMin,
              propertyName: "phoneLimitMin",
              handlePropChange,
            }}
          />
          <InputClone
            {...{
              type: "number",
              label: "Phone Limit Max",
              property: clonePlayer.phoneLimitMax,
              propertyName: "phoneLimitMax",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "number",
              label: "Web Limit Min",
              property: clonePlayer.webLimitMin,
              propertyName: "webLimitMin",
              handlePropChange,
            }}
          />
          <InputClone
            {...{
              type: "number",
              label: "Web Limit Max",
              property: clonePlayer.webLimitMax,
              propertyName: "webLimitMax",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "number",
              label: "Settle Figure",
              property: clonePlayer.settleFigure,
              propertyName: "settleFigure",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "text",
              label: "First Name",
              property: clonePlayer.firstName,
              propertyName: "firstName",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "text",
              label: "Last Name",
              property: clonePlayer.lastName,
              propertyName: "lastName",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "text",
              label: "Phone",
              property: clonePlayer.phone,
              propertyName: "phone",
              handlePropChange,
            }}
          />
        </Grid>
        <Grid container spacing={8} alignItems="flex-end">
          <InputClone
            {...{
              type: "text",
              label: "Email",
              property: clonePlayer.email,
              propertyName: "email",
              handlePropChange,
            }}
          />
        </Grid>
      </React.Fragment>
    );
  }
}

ClonePlayerInputForm.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  clonePlayer: PropTypes.object.isRequired,
  handlePropChange: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "ClonePlayerInputForm",
    withTheme: true,
  }),
)(ClonePlayerInputForm);
